import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Form } from '@/components';
import { Link } from 'react-router-dom';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledMainTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 2rem;
  padding-bottom: 0;
  align-items: start;
  background-color: ${COLORS.GRAY_LIGHT};
  border-bottom: 1px solid ${COLORS.GREY};
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 2rem;
`;

export const StyledLink = styled(Link)`
  ${pickThemeFontStyles('14', '18')};
  color: ${COLORS.NORMAL_GRAY};
  text-decoration: underline;
`;

export const StyledTitleAndLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.375rem;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('30', '30', 'BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
`;

export const StyledPageDescription = styled.div`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.BLACK};
  text-align: left;
`;

export const StyledTabTitleWrapper = styled.div`
  padding: 1rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
`;

export const StyledForm = styled(Form)`
  width: 100%;
`;
